/* src/app/rt-components/card/card.component.scss */
:host {
  display: block;
  margin: 0 0 1.5714286rem;
}
:host .card-wrap {
  background-color: #fff;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  border: 1px solid #fff;
  box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.25);
  position: relative;
}
:host .card-wrap:not(.outline-card) {
  border: 0 !important;
}
:host .card-wrap .card-header {
  background: #3c4e62;
  border-radius: 0;
  color: #fff;
  display: block;
  margin: -1px -1px 0 -1px;
  padding: 0.7857143rem 1.5714286rem;
  position: relative;
}
:host .card-wrap .card-content {
  display: block;
  padding: 1.5714286rem;
  position: relative;
}
:host .card-wrap.success-card {
  background: #008000;
  border-color: #008000;
}
:host .card-wrap.success-card:not(.outline-card) {
  color: #fff;
}
:host .card-wrap.info-card {
  background: #00bfff;
  border-color: #00bfff;
}
:host .card-wrap.info-card:not(.outline-card) {
  color: #fff;
}
:host .card-wrap.warning-card {
  background: #ff8c00;
  border-color: #ff8c00;
}
:host .card-wrap.warning-card:not(.outline-card) {
  color: #fff;
}
:host .card-wrap.danger-card {
  background: #dc143c;
  border-color: #dc143c;
}
:host .card-wrap.danger-card:not(.outline-card) {
  color: #fff;
}
:host .card-wrap.success-color-card {
  color: #008000;
}
:host .card-wrap.info-color-card {
  color: #00bfff;
}
:host .card-wrap.warning-color-card {
  color: #ff8c00;
}
:host .card-wrap.danger-color-card {
  color: #dc143c;
}
:host .card-wrap.outline-card {
  background: none !important;
  box-shadow: none !important;
}
:host .card-wrap.bg-image-card {
  border: none !important;
}
:host .card-wrap.bg-image-card:before {
  background-color: inherit;
  content: "";
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
/*# sourceMappingURL=card.component.css.map */
